<template>
    <el-dialog :title="$t('users.dialog_title')" :visible.sync="showPopup" append-to-body  class="my-dialog-class">
        
        <el-form :label-position="'top'" :inline="false"  
            :rules="rules"
            label-width="100%"  :model='selectedObject'  ref='my-form' @submit.prevent="save" v-loading="loading">
             <el-row :gutter="12">
                 <el-col :span="12">
                    <el-form-item :label="$t('users.name')" prop="Name" :required="true">
                        <el-input  v-model="selectedObject.Name" :placeholder="$t('users.name')" autofocus></el-input>
                    </el-form-item>
                 </el-col>
                 <el-col :span="12">
                    <el-form-item :label="$t('users.email')" prop="Email" :required="true">
                        <el-input v-model="selectedObject.Email" :placeholder="$t('users.email')"></el-input>
                    </el-form-item>
                 </el-col>

                <el-col :span="12">
                    <el-form-item :label="$t('users.user_group')" prop="IdUserGroup" :required="true">
                        <el-select v-model="selectedObject.IdUserGroup" :placeholder="$t('users.user_group')" class="full-width">
                            <el-option v-for="item in groups" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
                        </el-select>
                    </el-form-item>
                 </el-col>

                <el-col :span="12">
                    <el-form-item :label="$t('users.user_factory')" prop="IdFactory" :required="true">
                        <el-select v-model="selectedObject.IdFactory" :placeholder="$t('users.user_factory')" class="full-width" @change="on_primary_factory_change">
                            <el-option v-for="item in factories" :key="item.Id" :label="format_factory(item)" :value="item.Id"></el-option>
                        </el-select>
                    </el-form-item>
                 </el-col>

                <el-col :span="24">
                    <el-form-item :label="$t('users.additional_factories')">
                        <el-select
                            v-model="selectedObject.AssignedFactoryIds"
                            :placeholder="$t('users.additional_factories_placeholder')"
                            class="full-width"
                            multiple
                            filterable
                            @change="on_assigned_factories_change">
                            <el-option v-for="item in selectable_factories" :key="item.Id" :label="format_factory(item)" :value="item.Id"></el-option>
                        </el-select>
                    </el-form-item>
                 </el-col>

                <el-col :span="12">
                    <el-form-item :label="$t('users.sso_status')" prop="SsoStatus" :required="true">
                        <el-select v-model="selectedObject.SsoStatus" :placeholder="$t('users.sso_status')" class="full-width">
                            <el-option :label="$t('users.pending_access')" value="pending"></el-option>
                            <el-option :label="$t('users.approved_access')" value="approved"></el-option>
                            <el-option :label="$t('users.blocked_access')" value="blocked"></el-option>
                        </el-select>
                    </el-form-item>
                 </el-col>

                <el-col :span="12" v-if="selectedObject.AzureObjectId">
                    <el-form-item :label="$t('users.azure_object_id')">
                        <el-input v-model="selectedObject.AzureObjectId" disabled></el-input>
                    </el-form-item>
                 </el-col>
             </el-row>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="showPopup=false">{{ $t("cancel") }}</el-button>
            <el-button type="primary" @click="save">{{ $t("confirm") }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import settings from "./../../backend/LocalSettings";
import { countryLabel } from "./../../utils/countries";

export default {
  name: "user-dialog",
  data () {
    return { 
      loading: false,
      showPopup: false,
      mode: 'add',
	      selectedObject: { Name:"", Password: "", Email: "", IdUserGroup : "-1", IdFactory : "-1", AssignedFactoryIds: [], SsoStatus: "approved" },
      groups: [],
      factories: [],
      rules: {
          Name: [ { required: true } ],
          Email: [ {required: true } ],
          IdUserGroup: [ {required: true } ],
          IdFactory: [ {required: true } ],
          SsoStatus: [ {required: true } ]
      }
    }
  },
  computed: {
      selectable_factories: function() {
          return this.factories.filter((factory) => parseInt(factory.Id) > 0);
      }
  },
  methods: {
     format_factory: function(factory) {
        if(!factory) return "";
        if(factory.Country) return factory.ShortCode + " - " + countryLabel(this, factory.Country);
        return factory.ShortCode;
     },
     normalize_factory_ids: function(value) {
        if(value == null || value === "") return [];
        if(typeof value === "string") value = value.split(",");
        if(!Array.isArray(value)) value = [value];
        var ids = value
            .map((id) => parseInt(id))
            .filter((id) => id > 0);
        return Array.from(new Set(ids));
     },
     ensure_primary_factory_is_assigned: function() {
        var primary = parseInt(this.selectedObject.IdFactory);
        this.selectedObject.AssignedFactoryIds = this.normalize_factory_ids(this.selectedObject.AssignedFactoryIds);
        if(primary > 0 && this.selectedObject.AssignedFactoryIds.indexOf(primary) === -1) {
            this.selectedObject.AssignedFactoryIds.unshift(primary);
        }
     },
     on_primary_factory_change: function() {
        this.ensure_primary_factory_is_assigned();
     },
     on_assigned_factories_change: function() {
        this.ensure_primary_factory_is_assigned();
     },
     show_me: function( selectedObject ) {
        this.mode = "edit";
        if( selectedObject == null ) {
            this.mode = "add";
            this.selectedObject.Name        = "";
	            this.selectedObject.Password    = "";
            this.selectedObject.Email       = "";
            this.selectedObject.SsoStatus   = "approved";
            this.selectedObject.AssignedFactoryIds = this.normalize_factory_ids(this.selectedObject.IdFactory);
        } else {
            this.selectedObject  = JSON.parse( JSON.stringify( selectedObject ) );
            if(!this.selectedObject.SsoStatus) this.selectedObject.SsoStatus = "approved";
            this.selectedObject.AssignedFactoryIds = this.normalize_factory_ids(this.selectedObject.AssignedFactoryIds);
        }
        this.ensure_primary_factory_is_assigned();
        this.showPopup       = true;
    },
    load_info: function(){
        this.loading = true;
        this.$http
          .post('users/get_dialog_info',  {} )
          .then(function (response) {
            this.loading = false;
            if( settings.verify_response(response, this.$rights)) {
              this.groups    = response.body.Groups;
              this.factories = response.body.Factories;
              if(!this.selectedObject.IdUserGroup || this.selectedObject.IdUserGroup == "-1") this.selectedObject.IdUserGroup = this.groups[0].Id;
              if(!this.selectedObject.IdFactory || this.selectedObject.IdFactory == "-1") this.selectedObject.IdFactory = this.factories[0].Id;
              this.ensure_primary_factory_is_assigned();
            } else {
              this.$router.push("/");
            }
          });
    },
    save: function() {
        this.$refs['my-form'].validate((valid) => {
          if (valid) {
            this.ensure_primary_factory_is_assigned();
            this.loading = true;
            this.$http
            .post('users/save',  { mode: this.mode, object: this.selectedObject } )
            .then(function (response) {
                this.loading = false;
                if( settings.verify_response(response, this.$rights)) {
                    if(response.body.ErrorMessage != "" )
                    {
                        this.$message.error( response.body.ErrorMessage );
                    } else {
                        this.showPopup = false;
                        this.$emit("save");
                    }
                    
                } else {
                    this.$router.push("/");
                }
            });
          }
        });
    }
  },
  mounted: function() {
      this.load_info();
  }
};
</script>

<style lang="less" scoped>
    .full-width {
        width: 100%;
    }
</style>
